document.querySelectorAll(".li-item-title").forEach((item,index)=>{
  item.addEventListener("click",()=>{
   window.scrollTo({
      top: 0,
      behavior: "smooth" // for smooth scrolling
    });

   document.querySelectorAll(".div_block_item").forEach((itemm,indexx)=>{
     if(index===indexx){
       itemm.style.display="flex"
     }else{
       itemm.style.display="none"
     }
   })
  })
})


document.querySelectorAll(".product-form__input--pill input[type=radio] + label")
  .forEach((label) => {
    label.addEventListener("click", () => {
      const radio = label.previousElementSibling;
      console.log(radio)

    });

   
  });

 document.addEventListener("DOMContentLoaded", function () {
        const element = document.querySelector("span.product_per_ft.highlight-per-foot");

        if (element) {
            element.style.display = "none";
            setTimeout(() => {
                element.style.display = "inline-block";
            }, 1000); 
        }




   
    });




document.addEventListener('DOMContentLoaded', function () {
  const fbtCheckboxes     = document.querySelectorAll('.fbt-checkbox');
  const totalPriceElement = document.querySelector('.fbt-total-price');
  const addToCartBtn      = document.querySelector('.fbt-add-to-cart');
  const mainCheckbox      = document.querySelector('.fbt-main-checkbox'); // disabled main

  if (!fbtCheckboxes.length || !totalPriceElement || !addToCartBtn || !mainCheckbox) return;

  // helpers
  const num = (v) => {
    if (v == null) return 0;
    // strip $ and commas if present
    const s = String(v).replace(/[$,]/g, '');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  };
  const getItemEl = (el) => el ? (el.closest('.fbt-info-item') || el.closest('[data-id]')) : null;
  const getPriceFor = (checkbox) => {
    const wrap = getItemEl(checkbox);
    return num(wrap?.dataset?.price ?? checkbox?.dataset?.price);
  };
  const getIdFor = (checkbox) => {
    const wrap = getItemEl(checkbox);
    const raw = (wrap?.dataset?.id ?? checkbox?.dataset?.id);
    const id  = parseInt(raw, 10);
    return Number.isFinite(id) ? id : null;
  };

  function updateTotalPrice() {
    let total = 0;

    // main product price (robust)
    total += getPriceFor(mainCheckbox);

    // accessories
    fbtCheckboxes.forEach((cb) => {
      if (cb === mainCheckbox) return;
      if (!cb.checked) return;
      total += getPriceFor(cb);
    });

    totalPriceElement.textContent = '$' + total.toFixed(2);
  }

  function toggleImageVisibility(checkbox) {
    if (checkbox === mainCheckbox) return; // don't hide main
    const wrap = getItemEl(checkbox);
    const id = wrap?.dataset?.id ?? checkbox?.dataset?.id;
    if (!id) return;
    const img = document.querySelector(`.image_icon_container[data-id='${id}']`);
    if (!img) return;
    img.classList.toggle('hidden', !checkbox.checked);
  }

  // init
  fbtCheckboxes.forEach((cb) => {
    toggleImageVisibility(cb);
    if (cb !== mainCheckbox) {
      cb.addEventListener('change', () => {
        updateTotalPrice();
        toggleImageVisibility(cb);
      });
    }
  });
  updateTotalPrice();

  // add to cart (batch)
  addToCartBtn.addEventListener('click', function () {
    const items = [];

    const mainId = getIdFor(mainCheckbox);
    if (mainId) items.push({ id: mainId, quantity: 1 });

    fbtCheckboxes.forEach((cb) => {
      if (cb === mainCheckbox || !cb.checked) return;
      const id = getIdFor(cb);
      if (id) items.push({ id, quantity: 1 });
    });

    if (!items.length) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(() => { window.location.href = '/cart'; })
    .catch(err => console.error('[FBT] add error:', err));
  });
});



// blogcategory
document.querySelectorAll(".category_list_item").forEach((item) => {
  item.addEventListener("click", () => {
    let categoryName = item.textContent.trim();
    let categoryHandle = categoryName.toLowerCase().replace(/\s+/g, '-');

    // Use ?category= instead of ?tag=
    window.location.href = `https://lumensdepot.com/blogs/lumensdepot-blog?category=${encodeURIComponent(categoryHandle)}`;
  });
});




document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const selectedCategory = params.get("category");
  console.log(selectedCategory,"selectedCategory")
  if (!selectedCategory) return;

  document.querySelectorAll(".blog-articles__article").forEach(article => {
    const tagsAttr = article.getAttribute("data-tags") || "";
    const tagsArray = tagsAttr.toLowerCase().split(",");
    console.log(tagsArray,"tagsArray")

    if (!tagsArray.includes(selectedCategory)) {
      article.remove();
    }
  });
});









// for form submit at different different account

// document.getElementById('custmshopifyForm').addEventListener('submit', function(e) {
  //   e.preventDefault();

  //   const form = e.target;
  //   const formData = new FormData(form);
  //   const statusBox = document.getElementById('formStatus');

  //   // Convert formData to URL encoded string
  //   const urlParams = new URLSearchParams();
  //   for (const pair of formData.entries()) {
  //     urlParams.append(pair[0], pair[1]);
  //   }

  //   fetch("https://script.google.com/macros/s/AKfycbyLiJ8bu3wcbbTDZI5FAOTJslcc3FFTIs5yZY6lS2YgOxbMuwcpaW6EnnJtJLT7xdE/exec", {
  //     method: 'POST',
  //     body: urlParams
  //   })
  //   .then(response => response.text())
  //   .then(responseText => {
  //     statusBox.textContent = "Message sent successfully!";
  //     form.reset();
  //   })
  //   .catch(error => {
  //     statusBox.textContent = "Message sent successfully!";
  //     statusBox.style.color="green"
  //     form.reset();
  //     // console.error("Form error:", error);
  //   });
  // });

  document.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('.faq_question_heading_container');

  // Hide all answers initially
  document.querySelectorAll('.faq_question_answer_container')
    .forEach(a => a.style.display = 'none');

  function toggleHeading(heading) {
    const answer = heading.nextElementSibling;
    if (!answer || !answer.classList.contains('faq_question_answer_container')) return;

    const isOpen = heading.classList.contains('is-open');

    // Close all
    document.querySelectorAll('.faq_question_answer_container').forEach(a => a.style.display = 'none');
    document.querySelectorAll('.faq_question_heading_container').forEach(h => h.classList.remove('is-open'));

    // If this one wasn't open, open it
    if (!isOpen) {
      answer.style.display = 'block';
      heading.classList.add('is-open');
    }
  }

  headings.forEach(h => {
    h.addEventListener('click', () => toggleHeading(h));

    // Make the arrow clickable too
    const arrow = h.querySelector('.faq_arrow_right');
    if (arrow) {
      arrow.addEventListener('click', (e) => {
        e.stopPropagation(); // avoid double-trigger
        toggleHeading(h);
      });
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const qs = document.querySelectorAll('.faq_question_container');
  const as = document.querySelectorAll('.faq_answer_container');
  as.forEach(a => a.style.display = 'none');

  qs.forEach((q, i) => {
    q.addEventListener('click', () => {
      
      const isOpen = as[i].style.display === 'block';
      as.forEach(a => a.style.display = 'none');
      qs.forEach(el => el.classList.remove('is-open'));
      if (!isOpen) { as[i].style.display = 'block'; q.classList.add('is-open'); }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const pinEl   = document.getElementById('wf-zip');    // ZIP / PIN code
  const cityEl  = document.getElementById('wf-city');   // input[type=text]
  const stateEl = document.getElementById('wf-state');  // select OR input
  const countryEl = document.getElementById('wf-country'); // optional

  async function lookupPostal(code) {
    const pin = (code || '').trim();
    if (!pin) return;

    const country = (countryEl && countryEl.value) ? countryEl.value : 'US';

    try {
      if (country === 'IN') {
        // INDIA: https://api.postalpincode.in/pincode/{PIN}
        const res = await fetch(`https://api.postalpincode.in/pincode/${encodeURIComponent(pin)}`);
        const data = await res.json();
        const ok = Array.isArray(data) && data[0]?.Status === 'Success';
        if (!ok) return;

        const po = data[0].PostOffice?.[0];
        if (!po) return;

        // District -> City, State -> full name
        if (cityEl)  cityEl.value  = po.District || '';
        setStateField(po.State); // India has full state name only
      } else {
        // US (default): https://api.zippopotam.us/us/{ZIP}
        const res = await fetch(`https://api.zippopotam.us/${country.toLowerCase()}/${encodeURIComponent(pin)}`);
        if (!res.ok) return;
        const data = await res.json();
        const place = data.places && data.places[0];
        if (!place) return;

        if (cityEl)  cityEl.value = place['place name'] || '';
        // Prefer state abbreviation if available
        const abbr = place['state abbreviation'];
        const full = place['state'];
        setStateField(abbr || full);
      }
    } catch (e) {
      // silent fail; user can type manually
      console.warn('Postal lookup failed:', e);
    }
  }

  function setStateField(val) {
    if (!stateEl || !val) return;

    // If it's a <select>, try to match by value (code) or text (full name)
    if (stateEl.tagName === 'SELECT') {
      const v = val.toString().toUpperCase().trim();
      const options = Array.from(stateEl.options);

      // 1) exact value match (e.g., "CA")
      let match = options.find(o => o.value.toUpperCase() === v);

      // 2) text match (e.g., "California")
      if (!match) match = options.find(o => o.text.toUpperCase() === v);

      if (match) stateEl.value = match.value;
    } else {
      // If it's an <input>, just set text
      stateEl.value = val;
    }
  }

  // Trigger on blur/change of PIN/ZIP
  ['blur', 'change'].forEach(evt => {
    pinEl && pinEl.addEventListener(evt, () => lookupPostal(pinEl.value));
  });
});


(function(){
  // 1) Paste your Apps Script Web App URL here:
  const ENDPOINT = "https://script.google.com/macros/s/AKfycbz5eBNA427W37FEkY2nBS5gy-L5E28h3iH3kvIZgEl_3Wv9I4Zk5jeJ4XYeJfi_OxbT/exec"
  // "https://script.google.com/macros/s/AKfycbySQGtfH8TVrAhYm_dDEVwwe-6ucNt1fBuDM50uFCt3dd7MJSjNaOCxdHFPDWTP54C2Zg/exec";

  function showStatus(el, msg, ok){
    if(!el) return;
    el.style.display = 'block';
    el.textContent = msg;
    el.style.color = ok ? 'green' : 'red';
  }

  document.querySelectorAll('form.js-gas-form').forEach(function(form){
    form.addEventListener('submit', async function(e){
      e.preventDefault();

      const btn = form.querySelector('[type="submit"]');
      const statusEl = form.querySelector('.form-status');

      // Button UX
      if (btn) {
        btn.disabled = true;
        btn.dataset.originalText = btn.textContent;
        btn.textContent = 'Sending…';
      }
      showStatus(statusEl, '', true);

      // Build payload
      const fd = new FormData(form);
      fd.append('form_name', form.dataset.formName || form.getAttribute('name') || 'Website Form');

      try {
        // Important: No custom headers (avoids CORS preflight with Apps Script)
        const res = await fetch(ENDPOINT, { method: 'POST', body: fd });

        if (res.ok) {
          showStatus(statusEl, 'Thanks! Your message has been sent.', true);
          form.reset();
        } else {
          showStatus(statusEl, 'Failed to send. Please try again.', false);
        }
      } catch (err) {
        showStatus(statusEl, 'Network error. Please try again.', false);
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.originalText || 'Submit';
        }
      }
    });
  });
})();

//for warranty claim
(function(){
  const drop = document.getElementById('wf-dropzone');
  const input = document.getElementById('wf-files');
  const list = document.getElementById('wf-filelist');

  if (!drop || !input) return;

  function renderList(){
    if (!list) return;
    list.innerHTML = '';
    if (!input.files || !input.files.length) return;
    for (const f of input.files) {
      const li = document.createElement('li');
      li.textContent = `${f.name} (${Math.round(f.size/1024)} KB)`;
      list.appendChild(li);
    }
  }

  // click/keyboard to open file picker
  drop.addEventListener('click', () => input.click());
  drop.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); }
  });

  // drag & drop support
  drop.addEventListener('dragover', (e) => { e.preventDefault(); drop.classList.add('is-over'); });
  drop.addEventListener('dragleave', () => drop.classList.remove('is-over'));
  drop.addEventListener('drop', (e) => {
    e.preventDefault();
    drop.classList.remove('is-over');

    const dt = new DataTransfer();
    // Keep existing files + new ones
    for (const f of input.files) dt.items.add(f);
    for (const f of e.dataTransfer.files) dt.items.add(f);
    input.files = dt.files;

    renderList();
  });

  input.addEventListener('change', renderList);
})();


// const wishlistBtns = document.querySelectorAll(".ld-wish-btn");
// const msgwishlist  = document.querySelector(".msg_wishlist_added");
// const msgcontainer = msgwishlist?.parentElement;
// const progressBar  = msgcontainer?.querySelector(".progress-bar");

// if (wishlistBtns.length && msgwishlist && msgcontainer && progressBar) {
//   let hideTimeout;

//   function showToast(text) {
//     msgwishlist.textContent = text;
//     msgcontainer.style.display = "block";

//     // restart animation (0% -> 100%)
//     progressBar.style.transition = "none";
//     progressBar.style.width = "0%";
//     void progressBar.offsetWidth; // reflow
//     progressBar.style.transition = "width 3s linear";
//     progressBar.style.width = "100%";

//     if (hideTimeout) clearTimeout(hideTimeout);
//     hideTimeout = setTimeout(() => {
//       msgcontainer.style.display = "none";
//       progressBar.style.transition = "none";
//       progressBar.style.width = "0%";
//     }, 3000);
//   }

//   wishlistBtns.forEach((btn) => {
//     btn.addEventListener("click", () => {
//       setTimeout(() => {
//         const isActive = btn.classList.contains("ld-active");
//         showToast(isActive ? "Added to your wishlist" : "Removed from your wishlist");
//       }, 100);
//     });
//   });
// }

// for share button
document.addEventListener('click', (e) => {
  const container = e.target.closest('.share_button_container-fordesktop');
  if (!container) return;

  // if the actual button was clicked, let it handle itself
  if (e.target.closest('.share-button__button')) return;

  const btn = container.querySelector('.share-button__button') 
           || document.querySelector('.share-button__button');
  btn?.click();
});

// for wishlistbutton on header
(function () {
  const ICON_SEL = ".wishlist_icon_for_desktop_custom";
  const TARGET_SEL = ".cUQjxl";

  // Utility: try several ways to "really" click an element
  function robustClick(el) {
    if (!el) return false;

    // If it contains a native clickable child, prefer that
    const nativeChild = el.querySelector('button, a, [role="button"], input[type="button"], input[type="submit"]');
    const target = nativeChild || el;

    try {
      // 1) Native click
      if (typeof target.click === "function") target.click();

      // 2) Mouse sequence (helps delegated listeners)
      ["mousedown", "mouseup", "click"].forEach(type => {
        target.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
      });

      // 3) Keyboard fallback for role-based buttons
      if (target.matches('[role="button"]')) {
        ["keydown", "keyup"].forEach(type => {
          target.dispatchEvent(new KeyboardEvent(type, { key: "Enter", code: "Enter", bubbles: true, cancelable: true }));
        });
      }
      return true;
    } catch (e) {
      console.warn("robustClick error:", e);
      return false;
    }
  }

  // Utility: wait for selector up to a timeout
  function waitForEl(selector, timeout = 1500, interval = 100) {
    return new Promise(resolve => {
      const start = performance.now();
      const tick = () => {
        const el = document.querySelector(selector);
        if (el) return resolve(el);
        if (performance.now() - start >= timeout) return resolve(null);
        setTimeout(tick, interval);
      };
      tick();
    });
  }

  const icon = document.querySelector(ICON_SEL);
  if (!icon) {
    console.log("wishlist icon not found");
    return;
  }

  icon.addEventListener("click", async (e) => {
    // If Klaviyo injects late, wait a bit
    let target = document.querySelector(TARGET_SEL) || await waitForEl(TARGET_SEL, 1200);

    if (!target) {
      console.log("wishlist not available yet");
      return;
    }

    // Ensure it’s interactable
    try { target.scrollIntoView({ block: "nearest", inline: "nearest" }); } catch (_) {}
    const ok = robustClick(target);

    if (!ok) {
      // last-resort: try its firstElementChild
      const child = target.firstElementChild;
      if (!robustClick(child)) {
        console.log("wishlist click failed");
      }
    }
  });
})();


// document.addEventListener("DOMContentLoaded", () => {
//   const wishIcon = document.querySelector(".ld-wish-icon");
//   const notSaved = wishIcon.querySelector(".notsaved");
//   const activeWish = wishIcon.querySelector(".active-ld-wishlist");

//   if (wishIcon && notSaved && activeWish) {
//     // initialize → show only "not saved"
//     notSaved.style.display = "block";
//     activeWish.style.display = "none";

//     wishIcon.addEventListener("click", () => {
//       const isActive = activeWish.style.display === "block";

//       if (isActive) {
//         // currently active → switch back to not saved
//         activeWish.style.display = "none";
//         notSaved.style.display = "block";
//       } else {
//         // currently not saved → switch to active
//         notSaved.style.display = "none";
//         activeWish.style.display = "block";
//       }
//     });
//   }
// });

let faq_item=document.querySelectorAll(".custom_faq_question_container.accordion");
faq_item.forEach((question_item,index)=>{
question_item.addEventListener("click",()=>{
 question_item.nextElementSibling.classList.toggle("block_content")
 question_item.classList.toggle("remove_bottom_border")
})
})







